import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MergeTimepickerComponent } from './merge-timepicker.component';
import { TimepickerPopupComponent } from './timepicker-popup/timepicker-popup.component';
import { TranslateModule } from '@ngx-translate/core';
import { ClickOutsideModule } from '../../directives/click-outside/click-outside.module';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    ClickOutsideModule
  ],
  declarations: [MergeTimepickerComponent, TimepickerPopupComponent],
  exports: [MergeTimepickerComponent]
})
export class MergeTimepickerModule {

}
